import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import Moment from 'moment';

import { OrderStatusActionEnum } from '../../../shared/enums.ts';

import { Table, Select, Button, Space, notification, Tooltip, Card, Collapse, Row, Col, Typography } from 'antd';
import { InfoCircleOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
// import Highlighter from 'react-highlight-words';
import { DeleteOutlined, EditOutlined, CheckCircleOutlined, CheckOutlined, CloseOutlined, DoubleLeftOutlined } from '@ant-design/icons';

import languageManager from '../../../services/languageManager';

import * as storeActions from './store/actions/purchase_orders';

import { startLoading, endLoading } from '../../../shared/utility';
import TableFilters from '../../common/components/TableFilters';

import Loader from '../../common/PageElements/Loader';
import PageHeader from '../../common/PageElements/PageHeader'
import DropdownMenu from '../../common/components/DropdownMenu';

class PurchaseOrdersList extends Component {
   state = {
      pageLoader: true,
      loaders: {
         downloadEDI: false
      },
      tableLoader: false,
      importBox: false,
      importLoader: true,
      itemList: [],
      fullListIds: [],
      yearsList: [],
      marketplacesList: [],
      searchText: '',
      searchedColumn: '',
      componentLanguage: this.props.authState.defaultLanguage,
      searchYear: Moment().year(),
      poPaginationParams: {
         current_page: 1,
         per_page: 50,
         total: 0,
      },
      selectedRowKeys: [],
      multipleActionLoader: false,
      multipleActionList: [
         {
            action: OrderStatusActionEnum.ACCEPT.toString(),
            name: 'Accetta ordini selezionati'
         },
         {
            action: OrderStatusActionEnum.REFUSE.toString(),
            name: 'Rifiuta ordini selezionati'
         },
         {
            action: OrderStatusActionEnum.PROCESS.toString(),
            name: 'Metti in lavorazione'
         },
      ],
      multipleExportLoader: false,
      multipleExportList: [
         {
            action: 'export_csv',
            name: 'Esporta selezionati in CSV'
         },
         {
            action: 'export_ria',
            name: 'Esporta selezionati per RIA'
         },
         {
            action: 'export_po_pivot',
            name: 'Esporta selezionati per PO pivot'
         },
         {
            action: 'export_ria_weekly_pivot',
            name: 'Esporta selezionati per RIA pivot settimanale'
         },
      ],
      feedback: {},
      searchOrderInput: null,

      filters: [],
      // filtersValues: {},
      appliedFilters: [],
   };

   getList = (paginationParams, filters) => {
      // asyncronous calls
      console.log(filters);
      this.setState({ tableLoader: true })
      return storeActions.getListExtended(paginationParams, filters)
         .then(response => {
            console.log(response);
            try {
               let updatedFilters = []
               for (let filter of response.list_filters) {
                  if (filter.type === 'date') {
                     if (filter.value) {
                        filter.value = Moment(filter.value, 'YYYY-MM-DD');
                     }
                  }
                  updatedFilters.push(filter);
               }

               this.setState({
                  itemList: response.data.data,
                  fullListIds: response.full_list_ids,
                  poPaginationParams: {
                     current_page: response.data.current_page,
                     per_page: response.data.per_page,
                     total: response.data.total
                  },

                  filters: updatedFilters,
                  appliedFilters: response.applied_filters,

                  tableLoader: false,
                  loaders: endLoading(this.state.loaders, 'downloadEDI')
               });
            } catch (e) {
               this.setState({ tableLoader: false })
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ tableLoader: false })
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   getComplements = () => {
      return storeActions.getPurchaseOrdersComplements()
         .then(response => {
            console.log(response);
            try {
               let list = []
               _.forEach(response.statusesList, function (value) {
                  list.push({ id: value.id, name: value.t_name })
               })
               this.setState({
                  complementsResponse: response,
                  yearsList: response.yearsList,
                  marketplacesList: response.marketplacesList,
               });
            } catch (e) {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   componentDidMount() {
      var initialFilters = {}
      if (this.props.match.params.status) {
         switch (this.props.match.params.status) {
            case 'pending':
               initialFilters.po_status_id = [1]
               break
            case 'accepted':
               initialFilters.po_status_id = [2, 3]
               break
         }
      }
      Promise.all([
         this.getList(this.state.poPaginationParams, initialFilters),
         this.getComplements()
      ]).then(() => {
         this.setState({
            filtersValues: initialFilters,
            pageLoader: false
         });
      });
   }

   componentDidUpdate = (prevProps, prevState) => {
      if (!_.isEqual(prevProps.match.params.status, this.props.match.params.status)) {
         this.setState({ pageLoader: true });
         var initialFilters = {}
         if (this.props.match.params.status) {
            switch (this.props.match.params.status) {
               case 'pending':
                  initialFilters.po_status_id = [1]
                  break
               case 'accepted':
                  initialFilters.po_status_id = [2, 3]
                  break
            }
         }
         Promise.all([
            this.getList(this.state.poPaginationParams, initialFilters),
            this.getComplements()
         ]).then(() => {
            this.setState({
               filtersValues: initialFilters,
               pageLoader: false
            });
         });
      }
   }

   importEdiFromAmazon = () => {
      this.setState({ loaders: startLoading(this.state.loaders, 'downloadEDI') });
      console.log("Import");
      storeActions.importEdiFromAmazon()
         .then(response => {
            console.log(response);
            try {
               this.getList(this.state.poPaginationParams, this.state.filtersValues);
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.success.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.downloadOk'),
                  icon: <CheckCircleOutlined className="color-green-I" />,
               })
            } catch (e) {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            if (this.props.commonState.debug) console.log(e);
         });

   }

   orderStatusHandler = (orderIds, newStatus) => {
      this.setState({ tableLoader: true });
      storeActions.updateOrderStatus(orderIds, newStatus)
         .then(response => {
            console.log(response);
            try {
               this.getList(this.state.poPaginationParams, this.state.filtersValues);
            } catch (e) {
               this.setState({ tableLoader: false });
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            this.setState({ tableLoader: false });
            if (this.props.commonState.debug) console.log(e);
         });
   }

   exportOrdersHandler = () => {
      this.setState({ multipleExportLoader: true });
      let now = Moment().format('YYYY.MM.DD-HH.mm.ss');
      let filename = now + '_export_orders.csv';
      console.log("Export orders", filename, this.state.selectedRowKeys);
      storeActions.exportOrders(filename, this.state.selectedRowKeys)
         .then(response => {
            try {
               console.log(response);
               this.setState({ multipleExportLoader: false });
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.exportOk'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            } catch (e) {
               this.setState({ multipleExportLoader: false });
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            this.setState({ multipleExportLoader: false });
            if (this.props.commonState.debug) console.log(e);
         });
   }
   exportForRIAHandler = () => {
      this.setState({ multipleExportLoader: true });
      let now = Moment().format('YYYY.MM.DD-HH.mm.ss');
      let filename = now + '_RIA.zip';
      storeActions.exportForRIA(filename, this.state.selectedRowKeys)
         .then(response => {
            try {
               console.log(response);
               this.setState({ multipleExportLoader: false });
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.exportOk'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            } catch (e) {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            this.setState({ multipleExportLoader: false });
            if (this.props.commonState.debug) console.log(e);
         });
   }
   exportForPOPivotHandler = () => {
      this.setState({ multipleExportLoader: true });
      let now = Moment().format('YYYY.MM.DD-HH.mm.ss');
      let filename = now + '_ORDERS.zip';
      storeActions.exportForPOPivot(filename, this.state.selectedRowKeys)
         .then(response => {
            console.log(response);
            this.setState({ multipleExportLoader: false });
            notification.success({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.confirm.exportOk'),
            })

         }).catch((e) => {
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            this.setState({ multipleExportLoader: false });
            if (this.props.commonState.debug) console.log(e);
         });
   }
   exportForRIAWeeklyPivot = () => {
      this.setState({ multipleExportLoader: true });
      let now = Moment().format('YYYY.MM.DD-HH.mm.ss');
      let filename = now + '_RIA_WEEKLY_PIVOT.csv';
      storeActions.exportForRIAWeeklyPivot(filename, this.state.selectedRowKeys)
         .then(response => {
            console.log(response);
            this.setState({ multipleExportLoader: false });
            notification.success({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.confirm.exportOk'),
            })

         }).catch((e) => {
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            this.setState({ multipleExportLoader: false });
            if (this.props.commonState.debug) console.log(e);
         });
   }

   onSelectChange = (selectedRowKeys) => {
      this.setState({ selectedRowKeys: selectedRowKeys });
   };
   selectAllHandler = () => {
      if (this.state.selectedAll) {
         this.setState({
            selectedAll: false,
            selectedRowKeys: [],
         });
      }
      else {
         this.setState({
            selectedAll: true,
            selectedRowKeys: this.state.fullListIds,
         });
      }
   }
   multipleActionHandler = (value) => {
      const props = value.item.props
      switch (props.action) {
         case OrderStatusActionEnum.ACCEPT.toString():
         case OrderStatusActionEnum.REFUSE.toString():
         case OrderStatusActionEnum.PROCESS.toString():
            this.orderStatusHandler(this.state.selectedRowKeys, props.action);
            break;
         case 'export_csv':
            this.exportOrdersHandler()
            break
         case 'export_ria':
            this.exportForRIAHandler()
            break
         case 'export_po_pivot':
            this.exportForPOPivotHandler()
            break
         case 'export_ria_weekly_pivot':
            this.exportForRIAWeeklyPivot()
            break
         default:
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            break

      }
   }

   setSearchYear = (year) => {
      this.setState({ searchYear: year });
   }

   handleTableChange = (pagination, filters, sorter, extra) => {
      console.log(pagination, filters, sorter, extra);
      const paginationParams = {
         current_page: pagination.current,
         per_page: pagination.pageSize,
      }
      this.getList(paginationParams, this.state.filtersValues);
   };

   submitFilters = (values) => {
      // console.log("Selected filters", values)
      Object.keys(values).forEach(function (key) {
         if (_.isArray(values[key])) {
            _.forEach(values[key], function (value, key, array) {
               if (Moment.isMoment(value)) {
                  array[key] = Moment(value).format('YYYY-MM-DD');
               }
            })
         } else if (Moment.isMoment(values[key])) {
            values[key] = Moment(values[key]).format('YYYY-MM-DD');
         }
      });
      this.setState({ filtersValues: values, selectedRowKeys: [] })
      this.getList(this.state.poPaginationParams, values);
   }
   resetFilters = () => {
      this.setState({ filtersValues: {}, selectedRowKeys: [] })
      this.getList(this.state.poPaginationParams, {});
   }

   render() {
      if (this.state.pageLoader) return <Loader />
      const { Title } = Typography
      const { Panel } = Collapse
      const { Option } = Select
      const table_columns = [
         {
            title: 'MP',
            width: 75,
            key: 'marketplace',
            fixed: 'left',
            sorter: (a, b) => a.marketplace.name.localeCompare(b.marketplace.name),
            render: (record) => (
               record.marketplace.name
            )
         },
         {
            title: 'Ordine',
            width: 100,
            key: 'purchase_order_number',
            fixed: 'left',
            sorter: (a, b) => a.purchase_order_number.localeCompare(b.purchase_order_number),
            // ...this.getColumnSearchProps('purchase_order_number', 'ordine'),
            render: (record) => (
               // <a href='!#' onClick={(e) => { e.preventDefault(); this.props.history.push('/purchase_orders/details/' + record.id) }}>{record.purchase_order_number}</a>
               // <a href={'/purchase_orders/details/' + record.id}>{record.purchase_order_number}</a>
               <Link
                  to={{
                     pathname: '/purchase_orders/details/' + record.id,
                  }}
               >
                  {record.purchase_order_number}
               </Link>
            )
         },
         // {
         //    title: 'Comparazione',
         //    width: 125,
         //    dataIndex: 'comparison',
         //    key: 'comparison',
         //    fixed: 'left',
         //    render: (record) => (
         //       record.comparison + '%'
         //    ),
         //    sorter: (a, b) => a.comparison - b.comparison,
         // },
         {
            title: 'Fornitore',
            width: 75,
            key: 'vendor',
            fixed: 'left',
            render: (record) => (
               record.vendor
            ),
            sorter: (a, b) => a.vendor.localeCompare(b.vendor),
         },
         {
            title: 'Ordinato il',
            width: 100,
            key: 'order_date',
            render: (record) => (
               Moment(record.order_date).format('L')
            ),
            sorter: (a, b) => a.order_date.localeCompare(b.order_date),
         },
         {
            title: 'Giorno',
            width: 100,
            key: 'order_day',
            render: (record) => (
               record.order_day
            ),
            sorter: (a, b) => a.order_day.localeCompare(b.order_day),
         },
         {
            title: 'Spedire a',
            key: 'amazon_warehouse',
            render: (record) => (
               record.amazon_warehouse ? record.amazon_warehouse.fc_code + ' - ' + record.amazon_warehouse.address : ''
            ),
            sorter: (a, b) => a.amazon_warehouse.fc_code.localeCompare(b.amazon_warehouse.fc_code),
            ellipsis: true,
         },
         // {
         //    title: 'Tipo di finestra',
         //    width: 200,
         //    key: 'shipment_type',
         //    fixed: 'left',
         //    render: (record) => (
         //       record.shipment_type
         //    ),
         //    sorter: (a, b) => a.shipment_type.localeCompare(b.shipment_type),
         //    ellipsis: true,
         // },
         // {
         //    title: 'Finestra',
         //    width: 150,
         //    key: 'shipment_window',
         //    render: (record) => (
         //       Moment(record.shipment_window_start).format('L') + Moment(record.shipment_window_end).format('L')
         //    ),
         //    sorter: (a, b) => a.shipment_window_start.localeCompare(b.shipment_window_start),
         // },
         {
            title: 'Inizio finestra',
            width: 100,
            key: 'shipment_window_start',
            render: (record) => (
               Moment(record.shipment_window_start).format('L')
            ),
            sorter: (a, b) => a.shipment_window_start.localeCompare(b.shipment_window_start),
         },
         {
            title: 'Fine finestra',
            width: 100,
            key: 'shipment_window_end',
            render: (record) => (
               Moment(record.shipment_window_end).format('L')
            ),
            sorter: (a, b) => a.shipment_window_end.localeCompare(b.shipment_window_end),
         },
         // {
         //    title: 'Prodotti',
         //    width: 75,
         //    dataIndex: 'order_lines_count',
         //    key: 'order_lines_count',
         //    fixed: 'left',
         //    sorter: (a, b) => a.order_lines_count - b.order_lines_count,
         // },
         {
            title: 'Quantità richiesta',
            width: 75,
            dataIndex: 'items_total',
            key: 'items_total',
            sorter: (a, b) => a.items_total - b.items_total,
         },
         {
            title: 'Quantità accettata',
            width: 75,
            dataIndex: 'quantity_accepted',
            key: 'quantity_accepted',
            sorter: (a, b) => a.quantity_accepted - b.quantity_accepted,
         },
         // {
         //    title: 'Articoli importati',
         //    width: 150,
         //    dataIndex: 'order_lines_count',
         //    key: 'order_lines_count',
         //    fixed: 'left',
         //    sorter: (a, b) => a.order_lines_count - b.order_lines_count,
         // },
         {
            title: 'Tot net',
            width: 100,
            key: 'price_total',
            render: (record) => (
               record.price_total + ' €'
            ),
            sorter: (a, b) => a.price_total - b.price_total,
         },
         {
            title: 'Stato', width: 180, key: 'status',
            render: (record) => (
               record.order_status_name
            ),
            sorter: (a, b) => a.order_status_name.localeCompare(b.order_status_name),
         },
         {
            title: 'Accettazione', width: 150, key: 'acceptance',
            render: (record) => ([
               !_.isNil(record.acceptance_date) ? Moment(record.acceptance_date).format('L LTS') : null,
               <br />,
               !_.isNil(record.acceptance_user) ? record.acceptance_user.firstname + ' ' + record.acceptance_user.lastname : null
            ]),
            sorter: (a, b) => {
               a = a.acceptance_date || ''
               b = b.acceptance_date || ''
               return a.localeCompare(b)
            }
            // sorter: (a, b) => a.order_status_name.localeCompare(b.order_status_name),
         },
         {
            title: 'Azioni',
            key: 'actions',
            fixed: 'right',
            align: 'right',
            width: 100,
            render: (text, record) => (
               <Space>
                  {
                     record.order_status && record.order_status.id === 1 ?
                        [
                           <Tooltip key='action_accept' title={languageManager.getMessage(this.props.commonState, 'common.accept_order')}>
                              <Button type="success" size="small"
                                 icon={<CheckOutlined />}
                                 onClick={() => this.orderStatusHandler([record.id], OrderStatusActionEnum.ACCEPT.toString())}
                              />
                           </Tooltip>,
                           <Tooltip key='action_refuse' title={languageManager.getMessage(this.props.commonState, 'common.refuse_order')}>
                              <Button type="danger" size="small"
                                 icon={<CloseOutlined />}
                                 onClick={() => this.orderStatusHandler([record.id], OrderStatusActionEnum.REFUSE.toString())}
                              />
                           </Tooltip>,
                           // <Tooltip key='action_test' title={languageManager.getMessage(this.props.commonState, 'common.test_order')}>
                           //    <Button type="danger" size="small"
                           //       icon={<InfoCircleOutlined />}
                           //       onClick={() => this.orderStatusHandler(record.id, 'TEST')}
                           //    />
                           // </Tooltip>
                        ]
                        : ''
                  }
                  <Link
                     to={{
                        pathname: '/purchase_orders/details/' + record.id,
                     }}
                  >
                     <Button type="primary" size='small'
                        icon={<EditOutlined />}
                     />
                  </Link>
                  {
                     record.order_status && _.includes([2, 3, 4,], record.order_status.id) ?
                        [
                           <Tooltip key='action_delete' title={languageManager.getMessage(this.props.commonState, 'common.delete_order')}>
                              <Button type="danger" size="small"
                                 icon={<DeleteOutlined />}
                                 onClick={() => this.orderStatusHandler([record.id], OrderStatusActionEnum.REFUSE.toString())}
                              />
                           </Tooltip>,
                           // <Tooltip key='action_test' title={languageManager.getMessage(this.props.commonState, 'common.test_order')}>
                           //    <Button type="danger" size="small"
                           //       icon={<InfoCircleOutlined />}
                           //       onClick={() => this.orderStatusHandler(record.id, 'TEST')}
                           //    />
                           // </Tooltip>
                        ]
                        : ''
                  }
                  {/* <Popconfirm
                     placement="topRight"
                     title="Cancelli?"
                     onConfirm={() => this.confirmHandler('deleteItem', record.id)}
                     okText="Yes"
                     cancelText="No"
                  >
                     <Button className="link"><i className="far fa-trash-alt"></i></Button>
                  </Popconfirm> */}
               </Space>),
         },
      ];
      const tableLayout = {
         bordered: true,
         ellipsis: true,
         size: "small",
         showSorterTooltip: false,
         loading: this.state.tableLoader,
         pagination: {
            pageSize: this.state.poPaginationParams.per_page,
            total: this.state.poPaginationParams.total,
            showSizeChanger: true,
            defaultPageSize: 50,
            size: "default",
            showTotal: total => total + (total > 1 ? ' ordini' : ' ordine')
         },
         onChange: this.handleTableChange
      }

      const { selectedRowKeys } = this.state;
      const rowSelection = {
         selectedRowKeys,
         onChange: this.onSelectChange,
         preserveSelectedRowKeys: true,
      };

      const importResult = (
         <Card title="Card title">
            <Card type="inner" title="Importazione EDI files" extra={<Button className="link">Chiudi</Button>}>
               Importazione EDI files in corso
            </Card>
         </Card>
      );

      const ordersTable = (
         <Table
            {...tableLayout}
            columns={table_columns}
            rowSelection={rowSelection}
            rowKey={(record) => (record.id)}
            dataSource={this.state.itemList}

         // rowClassName={(record, index) => {
         //    record.order_day==='Monday' % 2 === 0 ? 'table-row-light' :  'table-row-dark'
         // }}
         />
      )

      const pageFilters = (
         <Collapse defaultActiveKey={['filters']}>
            <Panel header="Filtri" key="filters">
               <TableFilters submitFilters={this.submitFilters} resetFilters={this.resetFilters} filters={this.state.filters} />
            </Panel>
         </Collapse>
      );

      // const apiFeedback = (
      //       <Alert
      //          closable
      //          message="Dettagli importazione"
      //          type="info"
      //          description={<List
      //             size="small"
      //             dataSource={this.state.response.details}
      //             renderItem={item => <List.Item className='padding-0-I'>{item}</List.Item>}
      //          />}
      //          showIcon
      //       />
      // )

      const hasSelected = selectedRowKeys.length > 0;
      const singleSelected = selectedRowKeys.length > 1;
      const pageContent = (
         <div>
            <div className="align-items-center row" style={{ marginTop: 15, marginBottom: 5 }}>
               <div className="col-sm-6">
                  <div className="d-none d-md-block">
                     <Space>
                        <Button
                           onClick={() => this.selectAllHandler()}
                        >{this.state.selectedAll ? 'Deseleziona' : 'Seleziona tutto'}
                        </Button>
                        <span>
                           {hasSelected ? singleSelected ? `${selectedRowKeys.length} elementi selezionati` : `${selectedRowKeys.length} elemento selezionato` : ''}
                        </span>
                        <DropdownMenu
                           type='primary'
                           title='Azioni multiple'
                           action={this.multipleActionHandler}
                           values={this.state.multipleActionList}
                           disabled={!hasSelected}
                           loading={this.state.multipleActionLoader}
                        />
                        <DropdownMenu
                           type='primary'
                           title='Esporta'
                           action={this.multipleActionHandler}
                           values={this.state.multipleExportList}
                           disabled={!hasSelected}
                           loading={this.state.multipleExportLoader}
                        />
                     </Space>
                  </div>
               </div>
               <div className="col-sm-6">
                  <div className="float-right d-none d-md-block">
                     <Space>
                     </Space>
                  </div>
               </div>
            </div>
            {ordersTable}
         </div >
      )

      const pageWrapper = (
         <div className="card">
            <div className="card-header">
               <Row gutter={16} align='middle'>
                  <Col>
                     <Title level={5}>{languageManager.getMessage(this.props.commonState, 'component.purchase_orders.title')}</Title>
                  </Col>
                  <Col flex='auto'></Col>
                  <Col>
                     <Space>
                        <Button
                           type='primary'
                           icon={<DownloadOutlined />}
                           onClick={() => this.importEdiFromAmazon()}
                           loading={this.state.loaders.downloadEDI}
                        >
                           Scarica EDI Amazon
                        </Button>
                        <Link to={{ pathname: "/purchase_orders/import/" }} >
                           <Button
                              type='primary'
                              icon={<UploadOutlined />}
                           >Importa ordini da CSV</Button>
                        </Link>
                        <Select
                           showSearch
                           className="width-70px-I"
                           placeholder="Seleziona la lingua"
                           defaultValue={this.state.componentLanguage}
                           optionFilterProp="children"
                           onChange={this.setDefaultLanguageHandler}
                        >
                           {
                              this.props.authState.userData.languages.map((lang) => {
                                 return <Option key={lang.value} value={lang.value}>{lang.label}</Option>
                              })
                           }
                        </Select>
                     </Space>
                  </Col>
               </Row>
            </div>
            {this.state.importBox ? importResult : null}
            <div className="card-body">
               <Row>
                  <Col span={24}>{pageFilters}</Col>
               </Row>
               {pageContent}
            </div>
            <div className="card-footer">
               <Row gutter={16}>
                  <Col>
                     <Space size='small'>
                        <Link to={{ pathname: "/" }} >
                           <Button icon={<DoubleLeftOutlined />}>
                              {languageManager.getMessage(this.props.commonState, 'common.back')}
                           </Button>
                        </Link>
                     </Space>
                  </Col>
                  <Col flex='auto'></Col>
                  <Col></Col>
               </Row>
            </div>
         </div>
      );

      const helpButton = {
         title: "Aiuto"
      }

      const buttons = [];
      buttons.push(helpButton);

      return (
         <div className="container-fluid">
            <div className="row">
               <div className="col">
                  {pageWrapper}
               </div>
            </div>
         </div>
      );
   }
}

const mapStateToProps = state => {
   return {
      authState: state.authenticationState,
      commonState: state.commonState,
   };
};

// const mapDispatchToProps = dispatch => {
//     return {
//         onFetchTaxRates: () => dispatch( actions.getTaxRatesList() )

//     };
// };

export default connect(mapStateToProps)(PurchaseOrdersList);